import React, { useRef, useState, useEffect } from 'react'

const reflow = element => element.offsetHeight

const NEXT_SLIDE = null

const Direction = {
  NEXT: 1,
  PREV: 2,
}

const Carousel = ({ images }) => {
  const slides = useRef()
  const [ pause, setPause ] = useState(false)
  const [ currSlide, setCurrSlide ] = useState(0)
  const [ prevSlide, setPrevSlide ] = useState(null)
  const [ direction, setDirection ] = useState(Direction.NEXT)

  const setSlide = (
    newSlide,
    newDirection = newSlide > currSlide ? Direction.NEXT : Direction.PREV,
  ) => {
    setCurrSlide(slide => {
      setPrevSlide(slide)
      return newSlide == NEXT_SLIDE
      ? slide + 1 >= images.length ? 0 : slide + 1
      : newSlide
    })
    setDirection(newDirection)
  }

  useEffect(() => {
    if (prevSlide == null)
      Array.prototype.forEach.call(slides.current.children, (slide, i) => {
        if (currSlide == i)
          slide.classList.add('active')
        else
          slide.classList.remove('active')

        slide.classList.remove('carousel-item-prev')
        slide.classList.remove('carousel-item-next')
        slide.classList.remove('carousel-item-left')
        slide.classList.remove('carousel-item-right')
      })
    else
      Array.prototype.forEach.call(slides.current.children, (slide, i) => {
        const [ orderClassName, directionalClassName ] =
          direction == Direction.NEXT
          ? [ 'carousel-item-next', 'carousel-item-left'  ]
          : [ 'carousel-item-prev', 'carousel-item-right' ]

        if (currSlide == i) {
          slide.classList.add(orderClassName)
          reflow(slide)
        }

        slide.classList.add(directionalClassName)
      })
  }, [ prevSlide, currSlide, slides.current ])

  useEffect(() => {
    if (pause) return

    const interval = setInterval(() => setSlide(NEXT_SLIDE, Direction.NEXT), 5000)
    return () => clearInterval(interval)
  }, [ pause ])

  return (
    <div
      className="carousel slide"
      onMouseEnter={() => setPause(true)}
      onMouseLeave={() => setPause(false)}
    >
      <ol className="carousel-indicators">
        {images.map((image, i) =>
          <li
            key={i}
            className={currSlide == i ? 'active' : null}
            onClick={() => setSlide(i)}
          ></li>
        )}
      </ol>
      <div className="carousel-inner" ref={slides}>
        {images.map((image, i) =>
          <div
            key={i}
            className="carousel-item active" // Hack for server-side rendering
            onTransitionEnd={() => setPrevSlide(null)}
          >
            <img src={image} className="d-block w-100" />
          </div>
        )}
      </div>
    </div>
  )
}

export default Carousel
